import {Activities} from 'types';
import React, { createContext, useContext, useMemo, useState } from 'react';

export interface Data {
  professionCode: string;
  professionDescription: string;
  answerQuestionnaires: {
    activityCode: string;
    answers: any[]
    questionnaireId: string
  }[],
  extraQuestions?: any[];
  nif: string;
  encryptString: string;
}

interface Questionnaire {
  questionnaireId: string,
  activityCode: string,
  answers: any[],
}

interface SessionContextProps {
  data: any;
  setData: React.Dispatch<React.SetStateAction<any>>;
  saveQuestionnaire: (answerData: Questionnaire, extraQuestions?: any[]) => any;
  activities: Activities[];
  setActivities: React.Dispatch<React.SetStateAction<Activities[]>>;
}

const SessionContext = createContext<SessionContextProps | undefined>(
  undefined,
);

export const SessionProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [data, setData] = useState<any>({});
  const [activities, setActivities] = useState<Activities[]>([]);

  const saveQuestionnaire = (answerData: Questionnaire, extraQuestions?: any[]) => {

    const answerQuestionnaires = (data as Data).answerQuestionnaires?.filter(q => q.questionnaireId !== answerData?.questionnaireId) ?? [];

    const newAnswerQuestionnaires = answerData ? [...answerQuestionnaires, answerData] : answerQuestionnaires;


    const answerExtraQuestionnaires = (data as Data).extraQuestions?.filter(q => !Array.isArray(extraQuestions) || !extraQuestions.some(e => e.questionCode === q.questionCode)) ?? [];

    const newAnswerExtraQuestionnaires = [...answerExtraQuestionnaires, ...extraQuestions || []];


    const newData: Data = {
      ...data,
      answerQuestionnaires: newAnswerQuestionnaires.length > 0 ? newAnswerQuestionnaires : [],
      extraQuestions: newAnswerExtraQuestionnaires.length > 0 ? newAnswerExtraQuestionnaires : [],
    };

    setData(newData);

    return newData;
  }

  const contextValue = useMemo(() => ({ data, setData, saveQuestionnaire, activities, setActivities }), [data, setData, saveQuestionnaire, activities, setActivities]);

  return (
    <SessionContext.Provider value={contextValue}>
      {children}
    </SessionContext.Provider>
  );
};

export const useSession = () => {
  const context = useContext(SessionContext);
  if (!context) {
    throw new Error('Error');
  }
  return context;
};
